import { Typography } from '@/components/atoms/Typography/Typography.styled';
import { medias } from '@/utils/sizes';
import { generateClampFromMax, generateClampFromMinMax } from '@/utils/styling';
import styled from 'styled-components';

export const ProjectsGrid = styled.div`
  --text-container-height: ${generateClampFromMinMax(50, 70)};

  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--spacing-component-inner);

  &.is-additional-list {
    padding-top: var(--spacing-component-inner);
  }

  &.not-additional-list {
    margin-bottom: var(--spacing-component-sm);
  }

  &.images-with-projects-list {
    img {
      z-index: 100;

      &:hover {
        transform: scale(1.02);
      }
    }
  }

  .video-container,
  .image-container {
    background-color: rgb(227, 227, 222);
  }

  a {
    position: relative;
    align-items: flex-start;
  }

  ${medias.max.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${medias.max.mobile} {
    grid-template-columns: repeat(1, 1fr);
  }

  .loader-spinner-animated {
    border: 1px solid var(--bg-main);
    border-bottom-color: transparent;
  }

  &.images-with-projects-list .disabled-link {
    cursor: zoom-in;

    &:hover {
      img {
        filter: none !important;
        transform: scale(1.02);
      }
    }
  }
`;

export const TextExclusiveContent = styled.div.withConfig({
  shouldForwardProp: (prop) => !['aspectRatio'].includes(prop),
})<{
  aspectRatio: string;
}>`
  box-sizing: border-box;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: var(--spacing-component-inner-sm);
  width: 100%;
  aspect-ratio: 1.5;
  top: 0;
  opacity: 0;
  transition: opacity var(--tr-base);
  z-index: 100;
`;

export const ProjectList = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isLoader', 'isLoading'].includes(prop),
})<{
  isLoader?: boolean;
  isLoading?: boolean;
}>`
  /* margin-bottom: var(--spacing-component-inner-2xl); */
  transition: opacity var(--tr-base);

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  &.is-private-presentation {
    padding-top: var(--spacing-component-inner-lg);
  }

  iframe {
    pointer-events: none;
  }

  &.specific-work-page-list {
    margin-bottom: 0;

    ${ProjectsGrid} {
      margin-bottom: 0;
    }
  }

  &.is-additional-list {
    margin-bottom: 0;
  }

  &.not-additional-list:nth-child(2),
  &.not-additional-list:nth-child(3) {
    border-top: 1px solid var(--c-border);

    ${medias.max.mobile} {
      border-top: none; 
    }
  }

  /* animation: fadeIn var(--tr-slow) forwards; */

  &[data-is-list]:nth-last-child(2) {
    margin-bottom: 0;
  }

  .project-image {
    animation: fadeIn 1s forwards;
  }
  
  .video-image-thumbnail {
    transition: opacity 0.3s, transform 0.3s;

    &:hover {
      opacity: 1 !important;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }


  &[data-loader='true'] {
    pointer-events: none;
  }

  a[data-is-private='true'] {
    pointer-events: none;
  }

  .disabled-link {
    &:hover {
      img, iframe {
        filter: blur(3px);
      }

      ${TextExclusiveContent} {
        opacity: 1;
      }
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  .empty-title {
    height: var(--spacing-component-inner);
  }

  ${medias.max.mobile} {
    margin-bottom: 0;
  }
`;

export const ListTitleAndLink = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-component-inner) 0;
  /* border-top: 1px solid var(--c-border); */

    .service-title {
      font-size: var(--fs-lg);

      + p {
        font-size: var(--fs-sm);

        ${medias.max.mobile} {
          font-size: var(--fs-base);
          color: var(--c-font-secondary);
          font-family: var(--ff-helvetica-light);
          padding-left: 2px;
          padding-top: 2px;
        }
      }
    }

  ${medias.max.tablet} {


    a {
      font-size: var(--fs-base);
      line-height: 40px;
    }
  }

  ${medias.max.mobile} {
    border-top: none;
    padding: 0 0 var(--spacing-component-inner) 0;
  }
`;

export const TitleContainer = styled.div`
  display: flex;

  a {
    align-items: normal;
  }

  ${Typography}:first-child {
    margin-right: ${generateClampFromMax(7)};
  }
`;

export const Project = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isPrivate'].includes(prop),
})<{
  isPrivate: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const TextContainer = styled.div`
  padding-top: var(--spacing-component-inner-xs);
  height: var(--text-container-height);
`;
